import React from 'react';
import { Clock } from 'lucide-react';
export function FeaturedStory() {
  return <article className="group cursor-pointer mb-12 border-b border-ink pb-12" data-id="element-1">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start" data-id="element-2">
        <div className="lg:col-span-8 relative" data-id="element-3">
          <div className="aspect-[16/9] overflow-hidden border border-gray-900" data-id="element-4">
            <img src="https://images.unsplash.com/photo-1504711434969-e33886168f5c?q=80&w=2070&auto=format&fit=crop" alt="Featured story" className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-700" data-id="element-5" />
          </div>
          <div className="absolute top-4 left-4 bg-accent text-white px-3 py-1 text-xs font-bold uppercase tracking-widest shadow-md" data-id="element-6">
            Breaking News
          </div>
        </div>

        <div className="lg:col-span-4 flex flex-col justify-center h-full" data-id="element-7">
          <div className="mb-4 flex items-center space-x-2" data-id="element-8">
            <span className="w-2 h-2 bg-accent rounded-full animate-pulse" data-id="element-9"></span>
            <span className="text-accent font-bold uppercase text-xs tracking-widest" data-id="element-10">
              Global Markets
            </span>
          </div>

          <h2 className="text-3xl md:text-4xl font-bold leading-tight mb-4 group-hover:text-ink-light transition-colors" data-id="element-11">
            Global Markets Rally as Central Banks Signal Major Policy Shift
          </h2>

          <p className="text-lg text-ink-light font-body leading-relaxed mb-6" data-id="element-12">
            In a coordinated move that surprised analysts worldwide, major
            central banks have announced a unified approach to interest rates,
            sparking a historic rally across Asian and European markets this
            morning.
          </p>

          <div className="flex items-center justify-between border-t border-gray-200 pt-4 mt-auto" data-id="element-13">
            <div className="flex flex-col" data-id="element-14">
              <span className="text-sm font-bold font-serif uppercase" data-id="element-15">
                By{' '}
                <span className="italic normal-case font-body font-normal text-gray-600" data-id="element-16">
                  Alexander Sterling
                </span>
              </span>
              <span className="text-xs text-gray-500 font-body mt-1" data-id="element-17">
                Senior Financial Correspondent
              </span>
            </div>
            <div className="flex items-center text-gray-500 text-xs font-body" data-id="element-18">
              <Clock className="w-3 h-3 mr-1" data-id="element-19" />
              <span data-id="element-20">Updated 10m ago</span>
            </div>
          </div>
        </div>
      </div>
    </article>;
}